import { Badge, Button, Grid, Typography, makeStyles } from "@material-ui/core";
import { CommentOutlined } from "@material-ui/icons";
import { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Comment from "./Comment";

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: 0,
		borderTop: "1px solid #E0E0E0",
		[theme.breakpoints.down("sm")]: {
			marginTop: theme.spacing(2),
		},
	},
}));

export default function CommentList(props) {
	const {
		loading,
		items,
		setItems,
		limit,
		setLimit,
		loadData,
		lengthComments,
		modalImage,
	} = props;
	const classes = useStyles();

	const [hasMore, sethasMore] = useState(true);

	const fetchData = async () => {
		try {
			const commentsFormServer = await loadData();

			const notes = commentsFormServer?.data?.notes || [];
			const lendata = commentsFormServer?.data?.lendata || 0;

			setItems([...notes]);

			if (notes.length >= lendata) {
				sethasMore(false);
			}

			setLimit(limit + 5);
		} catch (error) {
			console.error("Error fetching data:", error);
			sethasMore(false);
		}
	};

	return (
		<Grid className={classes.root}>
			<Typography
				variant="h5"
				color="textSecondary"
				style={{ marginBottom: "1rem", marginTop: "1rem" }}
			>
				<Badge
					color="primary"
					badgeContent={lengthComments}
					showZero
					style={{ marginRight: "15px" }}
				>
					<CommentOutlined />
				</Badge>
				Comment{lengthComments > 0 ? "s" : ""}
			</Typography>

			{lengthComments === 0 && !loading ? (
				<Button variant="contained" color="primary" fullWidth disableElevation>
					Be the first to comment
				</Button>
			) : null}

			<InfiniteScroll
				dataLength={items?.length} //This is important field to render the next data
				next={fetchData}
				hasMore={hasMore}
				loader={<h4>Loading....!</h4>}
				endMessage={
					<p style={{ textAlign: "center" }}>
						<b>Yay! You have seen it all</b>
					</p>
				}
			>
				{items?.map((comment, index) => (
					<Comment key={index} comment={comment} modalImage={modalImage} />
				))}
			</InfiniteScroll>
		</Grid>
	);
}
